import { Trans } from 'next-i18next'

export default function MqOnboardingHeader({
  translationKey,
  className,
  elementClassName,
  transValues,
}: {
  translationKey: string
  className?: string
  elementClassName?: string
  transValues?: any
}): React.ReactElement {
  return (
    <h1
      className={` text-white  ${
        className ? className : 'text-6 md:text-8 leading-7 md:leading-9 font-semibold tracking-btn-wide'
      }`}
    >
      <Trans
        components={{
          orange: <span className={elementClassName ? elementClassName : 'text-orange font-bold'} />,
          br: <br />,
          green: (
            <span
              className="font-bold"
              style={{
                background: 'var(--puzzle-color, linear-gradient(224deg, #CEDA5F 28.01%, #74EB95 88.73%))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            />
          ),
          italic: <span className="italic" />,
        }}
        i18nKey={translationKey}
        values={transValues}
      />
    </h1>
  )
}
